import { useBreakpoint } from "@/base/utils/index";
import { createStyles } from "antd-style";

const useStyles = createStyles(({ token, css }: any) => ({
  root: css`
    background: ${token.ColorFigmaNeutralGrayscaleGray10};
    min-height: 100vh;
    position: fixed;
    inset: 0;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
}));

export const usePageError404Styles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
